var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getAccessToken, getSession } from "../utils/auth0";
/**
 * Safely parse JSON response, falling back to text if JSON parsing fails
 */
function safeJson(response) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return (yield response.clone().json());
        }
        catch (_a) {
            return response.text();
        }
    });
}
/**
 * Handler for fetching user entitlements from the ECO Gateway.
 * This endpoint acts as a secure server-side proxy to the ECO Gateway user preference service.
 *
 * @param req - The Next.js API request
 * @param res - The Next.js API response
 */
export function handleIdentityEntitlements(req, res) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        if (req.method !== "POST") {
            res.status(405).json({ message: "Method not allowed" });
            return;
        }
        try {
            const session = yield getSession(req, res);
            if (!(session === null || session === void 0 ? void 0 : session.user)) {
                res.status(401).json({ message: "Not authenticated" });
                return;
            }
            const { userId, accountId } = req.body;
            const hasValidUserId = userId !== undefined && userId !== null && userId !== "";
            const hasValidAccountId = accountId !== undefined && accountId !== null && accountId !== "";
            if (!hasValidUserId || !hasValidAccountId) {
                res.status(400).json({ message: "userId and accountId are required" });
                return;
            }
            const { accessToken } = yield getAccessToken(req, res);
            // Call the ECO Gateway user preference service to get user entitlements
            // Note: This uses the ECO_GATEWAY_BASE_URL from environment or defaults to dev
            const ecoGatewayUrl = (_a = process.env.ECO_GATEWAY_BASE_URL) !== null && _a !== void 0 ? _a : "https://wh-gateway.dev.coreservices.zones.dtn.com/v1";
            const entitlementsUrl = `${ecoGatewayUrl}/user-pref-service/get-user-preference`;
            const payload = {
                userId,
                accountId,
            };
            const upstream = yield fetch(entitlementsUrl, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify(payload),
                cache: "no-store",
            });
            if (!upstream.ok) {
                const errorBody = yield safeJson(upstream);
                // eslint-disable-next-line no-console
                console.error("ECO Gateway error:", {
                    status: upstream.status,
                    body: errorBody,
                });
                res.status(upstream.status).json({
                    message: "Failed to fetch entitlements from ECO Gateway",
                    upstreamStatus: upstream.status,
                    error: errorBody,
                });
                return;
            }
            const entitlementsData = yield upstream.json();
            // Set cache headers to prevent stale data
            res.setHeader("Cache-Control", "no-store");
            res.status(200).json(entitlementsData);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error("Entitlements endpoint error:", error);
            res.status(500).json({
                message: "Internal server error",
                error: error instanceof Error ? error.message : "Unknown error",
            });
        }
    });
}
